export const BracketsLine = () => {
  return (
    <div className="flex justify-start items-center ml-52 -mt-[110px]">
      <div className="flex justify-start items-start w-[58px] flex-wrap rounded">
        <div className="w-[48px] h-[1px] bg-gray-100"></div>
        <div className="w-[48px] h-[1px] bg-gray-100 mt-[82px]"></div>
      </div>
      <div className="-mx-[30px] rounded">
        <div className="w-[41px] h-[1px] bg-gray-100 rotate-90 mb-5"></div>
        <div className="w-[48px] h-[1px] bg-gray-100 mx-5"></div>
        <div className="w-[41px] h-[1px] bg-gray-100 rotate-90 mt-5"></div>
      </div>
    </div>
  );
};
